import { KeyValue } from '@/main/models/common';
import { PackageTypes, PackageActionTypes } from './packageTypes';
import { PackageTypeDomainRequest } from '@/main/models/request';

export function getPackage(
  request: PackageTypeDomainRequest
): PackageActionTypes {
  return {
    type: PackageTypes.GET_PACKAGE,
    payload: { request }
  };
}

export function savePackage(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): PackageActionTypes {
  return {
    type: PackageTypes.SAVE_PACKAGE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerPackage(): PackageActionTypes {
  return {
    type: PackageTypes.RESET_REDUCER_PACKAGE
  };
}

